import { Stack } from '@chakra-ui/react';
import { getTranslations } from 'next-intl/server';

import { SavedJobListContainer } from '@/modules/job/presentation/containers';
import { SectionTitle } from '@/modules/shared/presentation';

export const SavedJobListScreen = async () => {
	const t = await getTranslations('interested.list');

	return (
		<Stack gap="md">
			<SectionTitle title={t('title')} />
			<SavedJobListContainer />
		</Stack>
	);
};
